module.exports = __webpack_public_path__ + "img/D_Results_Units.09bedeed.svg";